import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { useLocation } from 'react-router-dom';

import { Routes } from './components/Routes';
import { Regions } from '../Regions/Regions';
import { Nav } from '../nav/nav';
import { Seo } from '../seo/seo';
import { ReadTopicDesktop } from '../read_topic/read_topic';
import { SeoUrlsDesktop } from '../seo_urls/seo_urls';
import { AdvertisingListContainer } from '../AdvertisingListContainer';
import { Search } from '../Search/Search';
import { DemandActivityPopup } from '../../components/realtor_demand/demand_activity_popup';
import { selectSearchShown } from '../../selectors/searchShown';
import { ApplicationContext } from '../../utils/applicationContext';
import { MainMenuContainer } from '../MainMenu';
import { selectSimilarArticles } from '../../selectors/similarArticles';
import { SimilarArticlesContainer } from '../SimilarArticles';
import s from './Layout.css';

export function Layout() {
  const isSearchShown = useSelector(selectSearchShown);
  const similarArticles = useSelector(selectSimilarArticles);
  const location = useLocation();
  const { pathname } = location;
  const {
    custom: { canSeeNewMenu },
  } = useContext(ApplicationContext);

  const deviceType = useDeviceType();
  const isDesktop = () => {
    return deviceType === 'desktop';
  };

  return (
    <section
      className={`${s['content']} ${isSearchShown ? s['content-search-visible'] : ''} ${
        canSeeNewMenu ? s['_with-new-menu'] : ''
      }`}
    >
      <Regions />
      <div
        className={`
                      ${s['content__container']} cg-container-fluid-xs
                      ${isSearchShown ? s['search-visible'] : ''}
                      ${canSeeNewMenu ? s['_with-new-menu'] : ''}
                    `}
      >
        {canSeeNewMenu ? (
          <div className={`${s['sidebar-new']}`}>
            <MainMenuContainer />
          </div>
        ) : (
          <div className={`cg-col-4 cg-col-xs-24 ${s['sidebar']}`}>
            <Nav />
          </div>
        )}

        <div className="cg-row">
          <div
            className={`
                          ${s['content__container_info']}
                          cg-col-20
                          cg-col-xs-24
                          ${canSeeNewMenu ? s['_with-new-menu'] : ''}
                        `}
          >
            <div className={`cg-row ${s['article-container']}`}>
              <Seo />
              <Routes />
            </div>
          </div>
        </div>
      </div>
      <div id="content-footer" className={s['content__read-topic']}>
        <div className={`cg-container-fluid-xs ${s['content-bottom-block']}`}>
          {similarArticles?.length ? (
            <div className={`cg-row`}>
              <div className="cg-col-20 cg-skip-4 cg-col-xs-16 cg-skip-xs-0">
                {isDesktop() && <SimilarArticlesContainer />}
              </div>
            </div>
          ) : (
            <>
              <div className={`cg-row ${s['read-topic-desktop']}`}>
                <div className="cg-col-20 cg-skip-4 cg-col-xs-16 cg-skip-xs-0">
                  {isDesktop() && <ReadTopicDesktop />}
                </div>
              </div>
              <div className={`cg-row ${s['read-topic-desktop']}`}>
                <div className="cg-col-20 cg-skip-4 cg-col-xs-16 cg-skip-xs-0">{isDesktop() && <SeoUrlsDesktop />}</div>
              </div>
            </>
          )}

          <div className="cg-row">
            <AdvertisingListContainer place="footer" />
          </div>
        </div>
      </div>
      <Search />
      <DemandActivityPopup pathname={pathname} />
    </section>
  );
}
